// src/components/common/ModalPortal.tsx
// Renders children directly into document.body via a React portal.
// Prevents position:fixed issues caused by overflow or transform on ancestor elements.
import React from "react";
import ReactDOM from "react-dom";

interface ModalPortalProps {
  children: React.ReactNode;
}

export const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  return ReactDOM.createPortal(children, document.body);
};